import React from 'react';
import './StatusPendingBttAgGridTable.css';

import BaseAgGridTable from 'Components/AgGrid/BaseAgGridTable';
import {
  dateColumn,
  firstName,
  lastName,
  destination,
  country,
  iataCode,
  season,
  staffSourceMarket,
  preferredFlightDate,
  typeOfFlight,
  greenLightUpdated,
} from 'Components/AgGrid/commonColumnDefs';

const columns = [
  dateColumn('Request date BTT', 'dateRequested'),
  greenLightUpdated('Greenlighted date HR'),
  firstName({ cellStyle: { fontWeight: 'bold' }, headerClass: 'ag-header-bold' }),
  lastName({ cellStyle: { fontWeight: 'bold' }, headerClass: 'ag-header-bold' }),
  destination(),
  country(),
  iataCode(),
  season(),
  staffSourceMarket(),
  preferredFlightDate(),
  typeOfFlight(),
];

const StatusPendingBttAgGridTable = () => (
  <BaseAgGridTable
    endpoint="staff/agGridTable/PendingBTT"
    viewName="StatusPendingBtt"
    statusPath="pendingbtt"
    columns={columns}
  />
);

export default StatusPendingBttAgGridTable;
